import { Dispatch, SetStateAction, useCallback } from "react";
import { SearchProposalsListView } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/search-proposals/SearchProposalsListView/SearchProposalsListView";

interface SearchProposalsProps {
  proposals: string[];
  searchQuery: string;
  showProposals: boolean;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  setSearchHistory: (value: string[]) => void;
  searchHistory: string[];
}

export const SearchProposals = ({
  proposals,
  searchQuery,
  showProposals,
  setSearchQuery,
  setSearchHistory,
  searchHistory,
}: SearchProposalsProps) => {
  const filteredProposals = proposals.filter(
    (proposal) => proposal.toLocaleLowerCase() !== searchQuery
  );

  const handleProposalClick = useCallback(
    (proposal: string) => {
      setSearchQuery(proposal);
      setSearchHistory([
        proposal,
        ...searchHistory.filter((name) => name !== proposal).slice(0, 9),
      ]);
    },
    [searchHistory, setSearchQuery, setSearchHistory]
  );

  if (!showProposals) return null;

  return (
    <SearchProposalsListView
      searchProposals={filteredProposals}
      handleProposalClick={handleProposalClick}
    />
  );
};
